import { observable, action, computed, runInAction } from 'mobx';
import ForInvestorsService from 'services/ForInvestors.service';


class ForInvestorsStore {
  @observable fetchedInvestorData = {};

  initialForInvestorsDataFetchDone = observable.box(false);

  constructor(coreStore) {
    this.coreStore = coreStore;
  }

  @computed
  get isLoaded() {
    return this.initialForInvestorsDataFetchDone.get();
  }

  @action
  async getForInvestorsData() {
    if (this.isLoaded) {
      return null;
    }
    try {
      const investorsData = await ForInvestorsService.fetchInvestorsData();
      runInAction(() => {
        this.fetchedInvestorData = investorsData
      });
    } catch (err) {
      console.log('error when fetching for investors data: ', err);
    }
  }
}

export default ForInvestorsStore;



// WEBPACK FOOTER //
// ./src/stores/ForInvestors.store.js